export default __webpack_public_path__ + "7e7e05fd035bb685f755bb3369d8b5f1.png";